import { useState } from "react";
import { ChevronDown, Menu, X } from "lucide-react";
import { ButtonLink, Frame, Logo } from "./primitives";

const LINKS = [
  { label: "Platform", href: "#coaching", menu: true },
  { label: "AI Assistant", href: "#agent", menu: true },
  { label: "For clients", href: "#clients" },
  { label: "Coaches", href: "#coaches" },
  { label: "Pricing", href: "#pricing" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-line bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80">
      <Frame className="flex h-[68px] items-center gap-7 px-4 sm:px-6">
        <Logo />
        <nav className="hidden items-center gap-1 text-[15px] text-ink md:flex">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="flex items-center gap-1 rounded-xl px-3 py-1.5 hover:bg-neutral-100"
            >
              {l.label}
              {l.menu && <ChevronDown className="h-3.5 w-3.5" strokeWidth={2} />}
            </a>
          ))}
        </nav>
        <div className="ml-auto flex items-center gap-2.5">
          <a href="/client" className="hidden whitespace-nowrap px-1 text-[14px] font-medium text-neutral-600 hover:text-ink lg:inline">
            Client login
          </a>
          <ButtonLink variant="light" href="/login" className="hidden h-9 px-4 sm:inline-flex">
            Coach login
          </ButtonLink>
          <ButtonLink href="/signup" className="h-9 px-4">
            Start for free
          </ButtonLink>
          <button
            type="button"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-[10px] border border-neutral-200 md:hidden"
          >
            {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
          </button>
        </div>
      </Frame>

      {open && (
        <div className="border-t border-line bg-white md:hidden">
          <Frame className="flex flex-col px-4 py-2">
            {LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="border-b border-line py-3 text-[15px] last:border-0"
              >
                {l.label}
              </a>
            ))}
            <a href="/login" className="border-b border-line py-3 text-[15px]">
              Coach login
            </a>
            <a href="/client" className="py-3 text-[15px]">
              Client login
            </a>
          </Frame>
        </div>
      )}
    </header>
  );
}
